import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ContentPassService } from 'src/app/services/content-pass.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-subscription-successful',
  templateUrl: './subscription-successful.component.html',
  styleUrls: ['./subscription-successful.component.scss']
})
export class SubscriptionSuccessfulComponent implements OnInit {

  @Input('data') data: any;
  sourceSku: any | null = null;
  destinationSku: any | null = null;
  noteText: String;
  flow: any = 'other';
  currentPlanDetails: any;
  paidPassesIcons: any[] = [];
  totalSelectedPasses: any[] = [];
  constructor(private modalController: ModalController,
    private aRoute: ActivatedRoute,
    private CPS: ContentPassService,
	private router: Router
  ) { 
    this.aRoute.queryParams.subscribe((q) => {
      if(q && q?.flow){
        this.flow = q?.flow;
      }
    })
  }

  ngOnInit(): void {
    this.sourceSku = this.CPS.getSourceSku()
    this.destinationSku = this.CPS.getDestinationSku()
    this.noteText = this.generateDisclaimerText();
    this.currentPlanDetails = this.CPS.getCurrentPlan();
    this.paidPassesIcons = this.CPS.getPaidPassesIcons();
    this.totalSelectedPasses = this.CPS.gettotalSelectedPasses();
    localStorage.removeItem('sourceSku')
    localStorage.removeItem('destinationSku')
    localStorage.removeItem('paidPassesIcons')
    localStorage.removeItem('totalSelectedPasses')
  }
  close(){
    this.modalController.dismiss();
  }
  generateDisclaimerText(){
	const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	let dates = this.getDatesObj();
    let text =   `Your ${this.sourceSku?.displayName} will remain active till end of the current month (till 
				${dates?.currentMonthEndDate.getDate()} of ${months[dates.currentMonthEndDate.getMonth()]}, ${dates?.currentMonthEndDate?.getFullYear()})
				and the new ${this.destinationSku?.displayName} will be activated starting next month (from ${dates?.nextMonthStartDate?.getDate()} of 
				${months[dates?.nextMonthStartDate?.getMonth()]}, ${dates?.nextMonthStartDate?.getFullYear()})`;
	return text;
  }
  getDatesObj(){
	let now = new Date();
	let currentMonthEndDate = new Date(now.getFullYear(), now.getMonth()+1 , 0);
	let nextMonthStartDate = new Date(now.getFullYear(), now.getMonth() +1, 1);

	return {currentMonthEndDate, nextMonthStartDate};
  }
  redirect(index: any){
	if(index == 0){		//redirect to manage subscription
		window.location.href = `${environment.HOST}/ecare/d/account-services/manage-extras`;
	}else if(index == 1){		//redirect to home page
		window.location.href = `${environment.HOST}'/ecare/d/dashboard`;
	}
  }
}
